import styled from 'styled-components';
import { Table } from 'antd';

interface TableProps {
  backgroundColor?: string;
  textAlign?: string;
  color?: string;
  padding?: string;
}

// compatibility error between TS and Styled, should be resolved when we will upgrade Styled
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const StyledTable = styled(Table).attrs({ bordered: true })<TableProps>`
  th {
    background-color: ${(props) =>
      props.backgroundColor ? props.backgroundColor : props.theme.colors.primary.main} !important;
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')} !important;
    color: ${(props) => (props.color ? props.color : props.theme.colors.common.white)} !important;
  }
  ant-table-cell .ant-table tbody > tr > td,
  .ant-table tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    position: relative;
    padding: ${(props) => (props.padding ? props.padding : '4px')} !important;
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')} !important;
  }
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th {
    padding: 8px;
  }
  .true {
    background-color: blue;
  }
  td table {
    margin: 20px 0px;
  }
  .table-row-light {
    background-color: #ffffff;
  }
  .table-row-dark {
    background-color: #ececec;
  }
`;
export default StyledTable;
